<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="1200"
    >
      <v-card class="mx-auto">
        <v-card-title
          class="title py-3"
          primary-title
        >
          Gửi Case chưa assign đến Kỹ thuật phù hợp
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-progress-linear :indeterminate="loading" v-if="loading"></v-progress-linear>
          <v-layout row v-else-if="tickets.length">
            <v-flex xs7 class="col-case pr-3">
              <div class="subheading font-weight-medium mb-2">
                <div class="">Cases</div>
              </div>
              <div class="list-case">
                <div 
                  class="list-case__item mb-2"
                  v-for="(ticket, indexTicket) in tickets"
                  :key="`ticket${indexTicket}`"
                  :class="{selected: selectedTicket && selectedTicket.Id === ticket.Id}" 
                  @click="onSelectTicket(ticket, indexTicket)"
                >
                  <div class="mb-1 d-flex">
                    <span class="font-weight-medium primary--text">#{{ticket.TicketCode}} - ({{ticket.TypeName}})</span>
                    <v-icon class="ml-auto cursoir-pointer" style="max-width: 4%;" @click="onDeleteCase(ticket.Id)">close</v-icon>
                  </div>
                  <p class="mb-1" v-html="ticket.Description"></p>
                  <p class="mb-0">
                    <b>Địa chỉ:</b> {{ticket.Address}}
                  </p>
                </div>
              </div>
            </v-flex>
            <v-flex xs5 class="pl-3">
              <div class="subheading font-weight-medium mb-2">Kỹ thuật</div>
              <div class="list-supporter" v-if="supporters">
                <div class="list-supporter__item mb-2" v-for="(supporter, index) in supporters" :key="`suppoter${index}`">
                  <p class="mb-0 font-weight-medium primary--text d-flex align-center">
                    {{supporter.Name}} ({{supporter.Group}})
                    <v-icon class="ml-auto cursor-pointer" style="max-width: 4%;" @click="onDeleteSuppoter(supporter.Id)">close</v-icon>
                  </p>
                  <p class="mb-0 mt-1">
                    <v-icon size="20">place</v-icon>
                    {{supporter.Address}} ({{supporter.Distance || 0 | roundTwoDecimal}} km)
                  </p>
                </div>
              </div>
               <p v-else>Không tìm thấy kỹ thuật phù hợp.</p>
            </v-flex>
          </v-layout>
          <p v-else>Không tìm thấy Case chưa được điều phối.</p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="onPushTicketNotAssign()"
            round
            class="text-capitalize px-4"
            :loading="loadingBtn"
            :disabled="!(tickets && tickets.length)"
          >
            Gửi Case
          </v-btn>
          <v-btn
            color="grey lighten-2"
            @click="close"
            round
            class="text-capitalize"
            style="min-width:85px"
            :disabled="loadingBtn"
          >
            Hủy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import _ from 'lodash';

export default {
  filters: {
    roundTwoDecimal (number) {
      if (!number) return number;

      return Math.round((number + Number.EPSILON) * 100) / 100;
    }
  },

  data: () => ({
    dialog: false,
    tickets: [],
    defaultSupporters: [],
    supporters: [],
    loading: false,
    selectedTicket: null,
    loadingBtn: false
  }),

  watch: {
    tickets: {
      deep: true,
      handler () {
        // console.log('🚀 ~ file: DialogTicketNotAssign.vue ~ line 154 ~ onDeleteSuppoter ~ this.tickets', this.tickets);
        this.getAllSuppoters();
      }
    }
  },

  methods: {
    ...mapActions(['GetTicketNotAssign', 'PushTicketNotAssign']),

    async open () {
      this.dialog = true;
      await this.getTicket();
    },

    close () {
      this.selectedTicket = null;
      this.supporters = [];
      this.dialog = false;
    },

    async getTicket () {
      this.loading = true;
      await this.GetTicketNotAssign().then(res => {
        this.tickets = res;
        this.getAllSuppoters();
      }).catch(() => {
        this.tickets = [];
      });
      this.loading = false;
    },

    getAllSuppoters () {
      this.defaultSupporters = [];
      this.tickets.forEach(item => {
        let sups = _.differenceBy(item.Supporters, this.defaultSupporters, 'Id');
        this.defaultSupporters = [...this.defaultSupporters, ...sups];
      });
      if (!this.selectedTicket) { this.supporters = [...this.defaultSupporters] }
    },

    onDeleteCase (tickedId) {
      this.tickets = this.tickets.filter(ticket => ticket.Id !== tickedId);
      this.getAllSuppoters();
    },

    onSelectTicket (ticket, indexTicket) {
      this.selectedTicket = { ...ticket };
      this.selectedTicket.index = indexTicket;
      this.supporters = [...this.selectedTicket.Supporters];
    },

    onDeleteSuppoter (supporterId) {
      if (!this.selectedTicket) { 
        this.tickets = this.tickets.map(ticket => {
          let obj = { ...ticket };
          obj.Supporters = ticket.Supporters.filter(supporter => supporter.Id !== supporterId);
          return obj;           
        });
      }
      else {
        this.supporters = this.supporters.filter(supporter => supporter.Id !== supporterId);
        this.tickets[this.selectedTicket.indexTicket] = [...this.supporters];
      }
    },

    async onPushTicketNotAssign () {
      this.loadingBtn = true;
      // console.log('🚀 ~ file: DialogTicketNotAssign.vue ~ line 166 ~ onPushTicketNotAssign ~ this.tickets', JSON.stringify(this.tickets));
      // return;
      let res = await this.PushTicketNotAssign(this.tickets).catch(() => {
        return false;
      });

      if (res) {
        window.getApp.showMessage('Gửi case tới kỹ thuật thành công!');
      }
      this.loadingBtn = false;
    }
  }
};
</script>

<style scoped>
.col-case{
  border-right: 1px solid rgba(0,0,0,0.2);
}
.list-case{
  max-height: calc(100vh - 280px);
  overflow: auto;
}
.list-case__item{
  background-color: #c8e4f580;
  padding: 10px 15px;
  border-radius: 16px;
  cursor: pointer;
  border: 2px solid transparent;
}
.list-case__item.selected{
  border-color: #1976d2;
}
.list-supporter{
  max-height: calc(100vh - 280px);
  overflow: auto;
}
.list-supporter__item{
  background-color: #c8e4f580;
  padding: 10px 15px;
  border-radius: 16px;
}
.cursoir-pointer{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/dispatch/components/DialogTicketNotAssign.vue